<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit User</p>
      </header>
      <section class="modal-card-body">
        <div class="column field">
          <b-field
            label="First Name*"
            custom-class="is-small"
          >
            <input
              @focus="$event.target.select()"
              class="input"
              type="name"
              maxlength="256"
              v-model="user.firstName"
              placeholder="First name"
              v-bind:expanded="true"
              required
              v-focus
              @keyup.enter="() => { saveUser(); $parent.close() }"
            />
          </b-field>
          <b-field
            label="First Name*"
            custom-class="is-small"
          >
            <input
              @focus="$event.target.select()"
              class="input"
              type="name"
              maxlength="256"
              v-model="user.lastName"
              placeholder="Last name"
              v-bind:expanded="true"
              required
              v-focus
              @keyup.enter="() => { saveUser(); $parent.close() }"
            />
          </b-field>
          <b-field
            label="Email*"
            custom-class="is-small"
          >
            <input
              @focus="$event.target.select()"
              class="input"
              type="email"
              minlength="4"
              maxlength="256"
              v-model="user.email"
              placeholder="Email"
              v-bind:expanded="true"
              required
              v-focus
              @keyup.enter="() => { saveUser(); $parent.close() }"
            />
          </b-field>

          <b-field
            label="Rights"
            custom-class="is-small"
          >
            <div class="block">
              <b-checkbox
                v-model="rightsGroup"
                native-value="Admin"
              >
                Admin
              </b-checkbox>
              <b-checkbox
                v-model="rightsGroup"
                native-value="Agent"
              >
                Agent
              </b-checkbox>
              <b-checkbox
                v-model="rightsGroup"
                native-value="SearchFree"
              >
                Search (free)
              </b-checkbox>
              <!-- <p class="content">
                                <b>Selection:</b>
                                {{ rightsGroup }}
                            </p> -->
            </div>
          </b-field>

        </div>

      </section>
      <footer class="modal-card-foot">
        <button
          class="button"
          type="button"
          @click="() => { cancelUser(); $parent.close() }"
        >Cancel</button>
        <button
          class="button is-primary"
          @click="() => { saveUser(); $parent.close() }"
        >Save</button>
      </footer>
    </div>
  </section>
</template>

<script>
import Helpers from "@/services/Helpers.js";

export default {
  components: {
    Helpers
  },

  props: {
    userToEdit: Object
  },

  data() {
    return {
      stages: Helpers.getStages(),
      originalNote: "",
      user: Object,
      rightsGroup: Object
    };
  },

  methods: {
    saveUser() {
      var userId = this.user.id;
      var rights = this.rightsGroup.join();
      this.$store.dispatch("updateUserRights", {
        userId,
        rights
      });
      this.$store.dispatch("updateUserFromAdmin", this.user);
    },

    cancelUser() {
      this.user = this.originalUser;
    }
  },

  mounted() {
    this.user = this.userToEdit;
    var rightsGroup = [];
    this.user.rights.forEach(function(right) {
      rightsGroup.push(right);
    });
    this.rightsGroup = rightsGroup;
  }
};
</script>

<style>
</style>
